import { usePaymentContext } from "pages/payment/providers/PaymentProvider";
import { useEffect, useState } from "react";
import { PaymentType } from "shared/utils/payment";
import Radio, { RadioVariant } from "shared/ui/radio";
import { concatClassnames } from "shared/utils/concatClassnames";

const paymentMethodsText = {
  ideal: "iDeal",
  creditcard: "Direct betalen met creditcard",
  spraypay: "Betaal gespreid met SprayPay",
  klarna: "Betaal met Klarna",
};
type paymentMethodsType = keyof typeof paymentMethodsText;

interface PaymentMethodListProps {
  paymentType: PaymentType;

  className?: string;
}
const PaymentMethodList = ({
  className,
  paymentType,
}: PaymentMethodListProps) => {
  const { bank, paymentMethod, setBank, setPaymentMethod } =
    usePaymentContext();

  useEffect(() => {
    if (!paymentType.methods.length) return;
    handleMethodChange(paymentType.methods[0].id);
  }, [paymentType.methods]);

  const handleMethodChange = (id: string) => {
    setPaymentMethod(id);
  };

  const handleBankChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setBank(event.target.value);
  };

  return (
    <div
      className={concatClassnames(
        "gg-flex gg-flex-col gg-space-y-2",
        className,
      )}
    >
      {paymentType.methods.map((method) => {
        return (
          <div
            className="gg-flex gg-flex-row gg-items-center gg-gap-4"
            key={`payment-type-${method.name}`}
          >
            <Radio
              variant={RadioVariant.CIRCLE}
              name="payment_method"
              id={`payment-method-${method.id}`}
              onChange={() => handleMethodChange(method.id)}
              checked={method.id === paymentMethod}
            />

            <div
              className={`gg-grid gg-w-full gg-grid-cols-12 gg-items-center gg-gap-x-4 md:gg-w-3/4 ${
                method.id === paymentMethod ? "gg-border-2" : "gg-border"
              } gg-rounded gg-border-dark-blue gg-p-2`}
            >
              <img
                alt="Bank logo"
                src={method.brand?.image}
                className="gg-col-span-2 gg-h-full gg-w-7 gg-object-contain"
              />

              <label
                className={`gg-col-span-10 ${
                  method.banks ? "md:gg-col-span-4" : "md:gg-col-span-10"
                } gg-text-md gg-align-middle`}
              >
                <div>
                  {
                    paymentMethodsText[
                      method.name.toLowerCase() as paymentMethodsType
                    ]
                  }
                </div>
              </label>

              {method.id === paymentMethod &&
                method.banks &&
                method.banks.length > 0 && (
                  <div className="gg-col-span-12 gg-pt-3 md:gg-col-span-6 md:gg-pt-0">
                    <select
                      id="bank-select"
                      name="bank"
                      value={bank}
                      onChange={handleBankChange}
                      className="gg-w-full gg-rounded gg-bg-gray-200 gg-p-2"
                    >
                      <option value="" className="gg-font-bold">
                        Kies een bank
                      </option>

                      {method.banks.map((bankItem) => (
                        <option
                          key={`bank-item-${bankItem.id}`}
                          value={bankItem.id}
                          className="gg-rounded gg-bg-gray-200 gg-p-1"
                        >
                          {bankItem.visibleName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default PaymentMethodList;
